export default __webpack_public_path__ + "static/media/sportsbra-large-front.339ad6e6.jpg";